import React from "react";
import FeatureDocumentation from "../../components/layouts/docsection";
import AddDiscount from "../../images/createDiscount.png"
 

const Discounts = () => {
  const DiscountsDoc = {
    title: "Discounts",
    description: "Learn how to efficiently manage product discounts, including how to create and apply various types of discounts.",
    sections: [
      {
        title: "Overview",
        content:
          "Discounts are incentives offered to customers in the form of free shipping, fixed discounts, or percentage discounts. **Please note** that all discounts must be discussed with management prior to execution. Ensure you fully understand the implications of your actions in this section, as changes are irreversible.",
      },
      {
        title: "Add Discount",
        content: 
          "Follow these steps to add a discount to your products.",
        image: AddDiscount,
        imageAlt: "Add discount to Products",
        imageCaption: "Figure 1: Comprehensive view of the Add Discount modal",
        subsections: [
          {
            title: "Create Discount",
            content: 
              "A modal will appear to guide you through the discount creation process.",
            steps: [
              "Discount Type: Choose from various discount options, including Percentage Discounts, Fixed Amount Discounts, or Free Shipping offers.",
              "Discount Properties: Specify the properties associated with the discount, which may vary based on the type selected.",
              "Discount Timeline: Define the start and end dates for the discount to specify its duration.",
              "Discount Description: Write a compelling and attractive description to inform customers about the discount and how to take advantage of it.",
            ],
          },
        ],
      },
    ],
  };
  
  return <FeatureDocumentation {...DiscountsDoc} />;
};

export default Discounts;
